export default __webpack_public_path__ + "static/media/实用新型专利证书.650563b6.png";